'use strict';

export default {
    collapsed(state, collapsed) {
        state.collapsed = collapsed;
    }
};
